import { ethers } from 'ethers';

export function formatUSDT(value) {
  if (!value) return '0.00';
  try {
    const formatted = ethers.utils.formatUnits(value, 18);
    const num = parseFloat(formatted);
    if (num === 0) return '0.00';
    if (num < 0.01) return '<0.01';
    return num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  } catch {
    return '0.00';
  }
}

export function formatCoin(value) {
  if (!value) return '0';
  try {
    const formatted = ethers.utils.formatUnits(value, 18);
    const num = parseFloat(formatted);
    return num.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  } catch {
    return '0';
  }
}

export function shortenAddress(addr) {
  if (!addr) return '';
  return addr.slice(0, 6) + '...' + addr.slice(-4);
}

export function formatDate(timestamp) {
  if (!timestamp || timestamp === 0) return 'N/A';
  const ts = typeof timestamp === 'object' ? timestamp.toNumber() : Number(timestamp);
  if (ts === 0) return 'N/A';
  return new Date(ts * 1000).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}

export function formatTimeRemaining(targetTimestamp) {
  const ts = typeof targetTimestamp === 'object' ? targetTimestamp.toNumber() : Number(targetTimestamp);
  const now = Math.floor(Date.now() / 1000);
  const diff = ts - now;
  if (diff <= 0) return 'Unlocked';
  const days = Math.floor(diff / 86400);
  const hours = Math.floor((diff % 86400) / 3600);
  if (days > 0) return `${days}d ${hours}h`;
  const mins = Math.floor((diff % 3600) / 60);
  return `${hours}h ${mins}m`;
}

export function parseUSDT(value) {
  return ethers.utils.parseUnits(value.toString(), 18);
}

export function toBN(value) {
  return ethers.BigNumber.from(value || 0);
}
